import React, { createContext } from 'react';
import { wrap } from '@hilma/tools';

import { FullStation } from '../types';

export const StationInfoContext = createContext<FullStation | null>(null);

interface StationInfoProviderProps {
	station: FullStation | null;
}

const StationInfoProvider: React.FC<StationInfoProviderProps> = ({ station, children }) => {
	return wrap(
		[StationInfoContext.Provider, { value: station }]
	)(children) as React.ReactElement;
}

export default StationInfoProvider;